<template>
    <div class="container-fluid corpo">
        <div class="row">
            <div class="col-12 col-sm-4 form-login bg-form">
                <div class="logo">
                    <img src="@/assets/img/lg_lliege.png" width="180" />
                </div>
                <br/>

                <div :is="componente"></div>

                <div class="mt-2 links">
                    <a class="text-dark" v-show="login" @click="rsenha"> Recuperar Senha?</a>
                    <a class="text-dark" v-show="!login" @click="voltar"> Realizar Login </a>
                </div>

            </div>
        </div>
        <div class="row footer col-12">
            <div class="col-12 col-sm-9 ml-4">
                <small>Copyright & Copyleft &copy; All material in this platform is the property of the contributing authors and partners.</small>
            </div>
            <div class="row col-12 col-sm-3 text-center mt-1 powerlliege">
                <small class="ml-5"><i> powered by</i><br>&copy;2014 - {{ new Date().getFullYear() }}</small>
                <img src="@/assets/img/lg_lliege_inline.png" alt="Logo Lliege" height="28">
            </div>
        </div>
    </div>
</template>

<script>
    import Login from "./Login";
    import RSenha from "./EsqueceSenha";

    export default {
        name: 'Layout',

        data() {
            return {
                componente: Login,
                login: true,
                usuario: ''
            }
        },

        components: {
            Login,
            RSenha
        },

        methods: {
            rsenha() {
                this.componente = RSenha;
                this.login = false;
            },

            voltar() {
                this.componente = Login;
                this.login = true;
            }
        }
    }
</script>

<style scoped>
    .corpo {
        font-family: 'Roboto',sans-serif;
        font-size: 14px;
        position: absolute;
        min-height: 100%;
        background-image: url('../../assets/img/bg_login.jpg') ;
        background-repeat: no-repeat;
        background-size: cover;
    }

    .form-login{
        text-align: center;
        margin: 0 auto;
        margin-top: 50px;
    }

    .links a{
        text-decoration: none;
        cursor: pointer;
    }
    .links a:hover {
        color: #f5911e !important;
    }

    .bg-form {
        background-color: #F5F5F5;
        min-height: 50vh;
        border-radius: 16px;
        padding: 15px;
    }
    .footer {
        position:fixed;
        bottom:0;
        margin-left: 1%;
    }

    @media screen and (max-width: 926px) {
        .footer img {
            margin-left: 15%;
        }
        .footer {
            margin-top: 30%;
            margin-left: -15px;
            position: relative;
        }
        .footer small,img {
            margin: 0 auto;
            padding: 0;
            margin-top: 4%;
        }


    }

</style>
